export default function countdown(){
  const countdown = document.querySelectorAll('[data-component="countdown"]')
  if (countdown.length == 0) return
  countdown.forEach((countdown) => {
    if (!countdown.getAttribute("data-countdown-date")) return;
    const endDate = new Date(countdown.dataset.countdownDate)
    countdown.dataset.countdownInterval = setInterval(() => calculate(countdown, endDate), 1000);
    calculate(countdown, endDate)
  })

  function calculate(element, endDate) {
    const startDate = new Date();
    const diff = endDate - startDate;

    if (diff <= 0) {
      clearInterval(element.dataset.countdownInterval)
      element.innerHTML = ""
      return
    }
    const days = Math.floor(diff / (1000 * 60 * 60 * 24)) + 1;
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    if (days >= 2) {
      element.innerHTML = `Restam ${days} dias - `
      return
    }

    element.innerHTML = `Restam ${padTime(hours)}h${padTime(minutes)}m${padTime(seconds)}s - `
  }

  function padTime(time){
    return String(time).padStart(2, "0")
  }
}
